import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({



  propTypes: {
    onChange: React.PropTypes.func,
    onHeightChange: React.PropTypes.func,
    textareaClassName: React.PropTypes.string,
    rows: React.PropTypes.number
  },

  getDefaultProps() {
    return {
      rows: 1
    };
  },

  getInitialState() {
    return {
      height: this.props.rows * 24
    };
  },

  componentDidMount() {
    this._syncHeightWithShadow();
  },

  render() {

    let {
      className,
      onChange,
      onHeightChange,
      textareaClassName,
      rows,
      valueLink,
    } = this.props;

    let classes = ClassNames('lui-enhanced-textarea');

    textareaClassName = 'lui-enhanced-textarea-input';

    let style = {
      height: this.state.height + 'px'
    };

    if (this.props.textareaClassName) {
      textareaClassName += ' ' + this.props.textareaClassName;
    }

    if (this.props.hasOwnProperty('valueLink')) {
      other.value = this.props.valueLink.value;
    }

    return (
      <div className={classes}>
        <textarea
          ref="shadow"
          className="lui-enhanced-textarea-shadow"
          tabIndex="-1"
          rows={this.props.rows}
          defaultValue={this.props.defaultValue}
          readOnly={true}
          value={this.props.value} />
        <textarea
          {...this.props}
          ref="input"
          className={textareaClassName}
          rows={this.props.rows}
          style={style}
          onChange={this._handleChange} />
      </div>
    );
  },

  getInputNode() {
    return this.refs.input.getDOMNode();
  },

  _syncHeightWithShadow(newValue, e) {
    let shadow = this.refs.shadow.getDOMNode();
    let currentHeight = this.state.height;
    let newHeight;

    if (newValue !== undefined) shadow.value = newValue;
    newHeight = shadow.scrollHeight;

    if (currentHeight !== newHeight) {
      this.setState({height: newHeight});
      if (this.props.onHeightChange) this.props.onHeightChange(e, newHeight);
    }
  },

  _handleChange(e) {
    this._syncHeightWithShadow(e.target.value);

    if (this.props.hasOwnProperty('valueLink')) {
      this.props.valueLink.requestChange(e.target.value);
    }

    if (this.props.onChange) this.props.onChange(e);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.value != this.props.value) {
      this._syncHeightWithShadow(nextProps.value);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/forms/enhanced-textarea/EnhancedTextarea.js
 **/